import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Index from "../views/index.vue";
import Content from "../views/content.vue";
import About from "../views/about/about.vue";
import AboutBrief from "../views/about/aboutBrief.vue";
import AboutOrgan from "../views/about/aboutOrgan.vue";
import AboutInvite from "../views/about/aboutInvite.vue";
import Company from "../views/company/company.vue";
import CompanyQualify from "../views/company/companyQualify.vue";
import CompanyHonor from "../views/company/companyHonor.vue";
import CompanyTeam from "../views/company/companyTeam.vue";
import News from "../views/news/news.vue";
import NewsCompany from "../views/news/newsCompany.vue";
import NewsBases from "../views/news/newsBases.vue";
import NewsNotice from "../views/news/newsNotice.vue";
import Policy from "../views/policy/policy.vue";
import PolicyNational from "../views/policy/policyNational.vue";
import PolicyLocal from "../views/policy/policyLocal.vue";
import PolicyIndustry from "../views/policy/policyIndustry.vue";
import PolicyCommon from "../views/policy/policyCommon.vue";
import Contact from "../views/contact.vue";
// import Culture from "../views/culture.vue";
import Search from "../views/search.vue";
import Sever from "../views/sever/sever.vue";
import SeverDetail from "../views/sever/severDetail.vue";
import Project from "../views/project/project.vue";
import ProjectDetail from "../views/project/projectDetail.vue";
import Team from "../views/team/team.vue";
import Books from "../views/books.vue";
import ContentTeam from "../views/contentTeam.vue";


Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "Index",
        component: Index,
        meta: {
            text: '1'
        }
    },
    {
        path: "/content",
        name: "Content",
        component: Content,
        // meta: {
        //     text: '1'
        // }
    },
    {
        path: "/books",
        name: "Books",
        component: Books
    },
    {
        path: "/about",
        name: "About",
        component: About,
        meta: {
            text: '2'
        },
        children: [{
                path: '/',
                name: 'AboutBrief',
                component: AboutBrief,
                meta: {
                    text: '2',
                    sub: 0
                },
            },
            {
                path: '/about/organ',
                name: 'AboutOrgan',
                component: AboutOrgan,
                meta: {
                    text: '2',
                    sub: 1
                },
            },
            {
                path: '/about/invite',
                name: 'AboutInvite',
                component: AboutInvite,
                meta: {
                    text: '2',
                    sub: 2
                },
            }
        ]
    },
    {
        path: "/company",
        name: "Company",
        component: Company,
        meta: {
            text: '3'
        },
        children: [{
                path: '/',
                name: 'CompanyQualify',
                component: CompanyQualify,
                meta: {
                    text: '3',
                    sub: 0
                },
            },
            {
                path: '/company/honor',
                name: 'CompanyHonor',
                component: CompanyHonor,
                meta: {
                    text: '3',
                    sub: 1
                },
            },
            {
                path: '/company/team',
                name: 'CompanyTeam',
                component: CompanyTeam,
                meta: {
                    text: '3',
                    sub: 2
                },
            }
        ]
    },
    {
        path: "/sever",
        name: "Sever",
        component: Sever,
        meta: {
            text: '4'
        }
    },
    {
        path: "/severDetail",
        name: "SeverDetail",
        component: SeverDetail,
        // meta: {
        //     text: '1'
        // }
    },
    {
        path: "/project",
        name: "Project",
        component: Project
    },
    {
        path: "/projectDetail",
        name: "projectDetail",
        component: ProjectDetail
    },
    {
        path: "/news",
        name: "News",
        component: News,
        meta: {
            text: '5'
        },
        children: [{
                path: '/',
                name: 'NewsCompany',
                component: NewsCompany,
                meta: {
                    text: '5',
                    sub: 0
                },
            },
            {
                path: '/news/bases',
                name: 'NewsBases',
                component: NewsBases,
                meta: {
                    text: '5',
                    sub: 1
                },
            },
            {
                path: '/news/notice',
                name: 'NewsNotice',
                component: NewsNotice,
                meta: {
                    text: '5',
                    sub: 2
                },
            }
        ]
    },
    {
        path: "/policy",
        name: "Policy",
        component: Policy,
        meta: {
            text: '6'
        },
        children: [{
                path: '/',
                name: 'PolicyNational',
                component: PolicyNational,
                meta: {
                    text: '6',
                    sub: 0
                },
            },
            {
                path: '/policy/local',
                name: 'PolicyLocal',
                component: PolicyLocal,
                meta: {
                    text: '6',
                    sub: 1
                },
            },
            {
                path: '/policy/industry',
                name: 'PolicyIndustry',
                component: PolicyIndustry,
                meta: {
                    text: '6',
                    sub: 2
                },
            },
            {
                path: '/policy/common',
                name: 'PolicyCommon',
                component: PolicyCommon,
                meta: {
                    text: '6',
                    sub: 3
                },
            }
        ]
    },
    {
        path: "/contact",
        name: "Contact",
        component: Contact,
        meta: {
            text: '7'
        }
    },
    {
        path: "/contentTeam",
        name: "ContentTeam",
        component: ContentTeam,
        meta: {
            text: '2'
        }
    },
    {
        path: "/search",
        name: "Search",
        component: Search,
    },
    {
        path: "/team",
        name: "Team",
        component: Team,
        meta: {
            text: '2'
        }
    },

];

const router = new VueRouter({
    mode: 'history',
    base: '/gsjtjlWeb/',
    routes
});

export default router;